import { ref, readonly } from 'vue';
import { DeviceInfo, Shopflow } from './index';

const deviceInfo = ref<DeviceInfo | null>(null);

export const useDeviceInfo = () => {
  const getInfo = async () => {
    if (deviceInfo.value) return deviceInfo.value;
    
    const info = await Shopflow.getDeviceInfo();
    deviceInfo.value = info;

    return info;
  };

  return {
    deviceInfo: readonly(deviceInfo),
    getInfo,
  }
}